import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './HeaderRow.css';

export interface IHeaderRowProps {
  position: number;
  ref?: React.Ref<HTMLDivElement>;
  sticky?: boolean;
}

function HeaderRow({ children, ref, sticky }: React.PropsWithChildren<IHeaderRowProps>): React.JSX.Element {
  return (
    <div ref={ref} className={clsx(style['row'], sticky && style['row--sticky'])}>
      {children}
    </div>
  );
}

export { HeaderRow };
